import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useReduxAction from 'hooks/useReduxAction'
import { SET_CURRENT_USER } from 'store/actions'

const useCurrentUser = () => {
  const { currentUser } = useSelector((state) => state.customization)

  const {
    errors,
    loaded,
    loading,
    result: current,
  } = useReduxAction('users', 'loadCurrentUser', {}, [], {
    shouldPerformFn: (entityReducer) => {
      const { errors, loaded, loading } = entityReducer
      return !loaded && !loading && !errors?.length && !currentUser
    },
  })

  const dispatch = useDispatch()

  useEffect(() => {
    if (current && !currentUser) {
      dispatch({ type: SET_CURRENT_USER, currentUser: current })
    }
  }, [current, currentUser, dispatch])

  return {
    currentUser,
    errors,
    loaded,
    loading,
  }
}

export default useCurrentUser
